import React, { useState } from "react";
import Card from "../components/person-card";
import "../styles/pages/teachers.css";
import { useNavigate } from "react-router-dom";
import { useTeachersData } from "../hooks/teacher/useTeachersData";
import { BsGearFill } from "react-icons/bs";
import { IoRemoveCircleOutline, IoAddCircleOutline } from "react-icons/io5";
import { ImArrowRight2 } from "react-icons/im";
import BackgroundLogo from "../components/background-logo";
import ConfirmationModal from "../components/confirmation-modal";
import useAuth from "../hooks/auth/useAuth";
import { authContextType } from "../@types/auth-types";
import api from "../util/api";

//pagina dos professores
function Teachers() {
  const navigate = useNavigate();
  const { user } = useAuth() as authContextType;
  console.log(user);
  const { data: teachers, isError, refetch } = useTeachersData(user.userId, user.token);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [isOptionsModalOpen, setIsOptionsModalOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleDelete = () => {
    if (selectedTeacher) {
      setIsConfirmationModalOpen(true);
    } else {
      setErrorMessage("Selecione um professor primeiro");
    }
    setIsOptionsModalOpen(false);
  };

  const handleOptions = () => {
    setIsOptionsModalOpen(!isOptionsModalOpen);
  };

  const handleAddTeacher = () => {
    setIsOptionsModalOpen(false);
    navigate("/addProfessor");
  };

  const handleNextPage = () => {
    navigate("/alunos");
  };

  const handleSelect = (id: string) => {
    setSelectedTeacher(id);
    if (isUpdateMode) {
      navigate(`/editarProfessor/${id}`);
    }
  };

  const handleUpdate = () => {
    if (selectedTeacher) {
      setIsOptionsModalOpen(false);
      navigate(`/editarProfessor/${selectedTeacher}`);
    }
  };

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Enter" && selectedTeacher && user.teacherId) {
      handleNextPage();
    }
  };

  const onConfirmDelete = async () => {
    try {
      api.defaults.headers.authorization = user.token;

      const response = await api.delete(`/professor/${selectedTeacher}`);

      if (response.status !== 200) {
        setErrorMessage("Não foi possível excluir o professor");
        return;
      }

      await refetch();
      setIsConfirmationModalOpen(false);
      setSelectedTeacher("");
      setIsDeleteMode(false);

    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Erro ao tentar excluir o professor");
    }
  };

  const onCancelDelete = () => {
    setIsConfirmationModalOpen(false);
    setErrorMessage(null);
  };

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [selectedTeacher, user.teacherId]); // Add dependencies for the effect

  return (
    <div className="background-teachers">
      <BackgroundLogo isAdminPage={false} />
      <div className="background-right-teachers">
        <div className="container-header-teachers">
          <BsGearFill
            className="options-header-teachers"
            onClick={handleOptions}
          />
          <div
            className={
              isOptionsModalOpen
                ? "options-container-teachers-enable"
                : "options-container-teachers-disable"
            }
            onClick={handleOptions}
          >
            <div className="option-teachers" onClick={handleAddTeacher}>
              <IoAddCircleOutline className="option-image-teachers" />
              <label>Adicionar</label>
            </div>
            <div className="option-teachers" onClick={handleDelete}>
              <IoRemoveCircleOutline className="option-image-teachers" />
              <label>Remover</label>
            </div>
            <div className="option-teachers" onClick={handleUpdate}>
              <IoAddCircleOutline className="option-image-teachers" />
              <label>Alterar</label>
            </div>
          </div>
        </div>
        <div className="container-teachers">
          <div className="container-content-teachers">
            <div className="label-title-teachers">Selecione o Professor</div>
            <div className="content-teachers">
              {(teachers?.length || 0) > 0 ? (
                teachers?.map((teacher) => (
                  <Card
                    key={teacher.id}
                    id={teacher.id}
                    nome={teacher.name}
                    imagem={teacher.image}
                    heroi={undefined}
                    situation="Professor"
                    delete={isDeleteMode}
                    update={isUpdateMode}
                    handleSelect={handleSelect}
                    selectedTeacher={selectedTeacher}
                    selectedStudent={null}
                  />
                ))
              ) : (
                <div className="label-no-teachers">
                  <label>
                    Ainda não temos professores cadastrados. Clique na
                    engrenagem e adicione os professores!
                  </label>
                </div>
              )}
            </div>
            <div className="container-arrows-teachers">
              {(teachers?.length || 0) > 0 ? (
                <ImArrowRight2
                  size={30}
                  className={
                    user.teacherId ? "arrow-teachers" : "arrow-teachers-disable"
                  }
                  onClick={handleNextPage}
               />
              ) : null}
            </div>
          </div>
        </div>
        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}
        {isConfirmationModalOpen && (
          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            message="Tem certeza que deseja remover o professor?"
            onClose={onCancelDelete}
            onConfirm={onConfirmDelete}
            onCancel={onCancelDelete}
          />
        )}
      </div>
    </div>
  );
}

export default Teachers;
